<template>
    <div class="container">
        <h2>Artwork Requirements</h2>
        <h3>Canvassing Cards</h3>
        <!-- FIXME: <p v-html="requirements"></p> -->
        <p></p>
    </div>
</template>

<script>
export default {
    name: 'artwork-requirements'
}
</script>

<style lang="sass" scoped>

</style>





// WEBPACK FOOTER //
// src/components/pages/artwork-requirements/artwork-requirements.vue